
import React, { Component } from "react";
import Button from '@material-ui/core/Button'
import '../App.css'
import { getAuthUserLists, deleteAuthUser} from '../services/userServices';
import { PropTypes } from "prop-types";
import { withStyles, } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import TopBar from '../components/TopBar'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



const styles = theme => ({
  root: {
   // display: "flex",

  },

  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  }
});

class ManageAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideCards: false,
      cardStyles: false,
      userId:'',
      id:'',
      admins:[],
      open:false,
      toBeDeleted: '',
      superadmin: false
    };
  }
  componentDidMount() {
    getAuthUserLists().then((response) => {
        console.log("response", response);
        this.setState({
            admins: response.reverse()
        });
        console.log("Admins", this.state.admins);
    })
        .catch((error) => {
            console.log(error);
        });
        if(sessionStorage.getItem("role")=== "superadmin"){
          this.setState({
            superadmin: true
        });
        }
}

  slideCards = () => {
    try {
      this.setState({ slideCards: !this.state.slideCards });
    } catch (err) {
      console.log("error at slideCards in dashBoard");
    }
  };
  /**
   * @description:it handles the cards style
   */
  handleCardStyle = () => {
    try {
      this.setState({ cardStyles: !this.state.cardStyles });
    } catch (err) {
      console.log("error at handleCardStyle in dashBoard");
    }
  };
  /**
   * @description:it display the new note
   * @param {*get new card or note} newCard
   */

  createTable = () => {
    let table = []
    for (let i = 0; i < this.state.admins.length; i++) {
      let children = []
      children.push(<td className="MyAdminTable"> {i+1} </td>,<td  className="MyAdminTable">{this.state.admins[i].firstName + ' ' + this.state.admins[i].lastName}</td>,
      <td className="MyAdminTable">{this.state.admins[i].email}
     { //Check if message failed
        (this.state.superadmin)
          ? <DeleteIcon onClick={() => this.handleClickOpen(this.state.admins[i])} style={{float:'right',cursor:'pointer'}}/> 
          : null
      }
      
      </td>)
       table.push(<tr>{children}</tr>)
    }
    return table
  }

  //To delete an admin
  deleteAdmin = () => {
    deleteAuthUser(this.state.toBeDeleted.UID).then((response) => {
     let myArray = this.state.admins.filter((obj)=>{
        return obj.UID !== this.state.toBeDeleted.UID;
    });
      this.setState({
        open: false,
        admins: myArray
      })
    })
      .catch((error) => {
        console.log(error);
      });
  }
  handleClickOpen = (uid) => {
    this.setState({
      open: true,
      toBeDeleted: uid
    })
  };
  handleClose = () => {
    this.setState({
      open: false
    })
  };




  render() {
    const { classes } = this.props;
    const slidingCards = this.state.slideCards ? "afterSlide" : "beforeSlide";
    return (
      <div className={classes.root}>
        <div className={slidingCards} id={slidingCards}>
          <div>
            <TopBar
              slideCards={this.slideCards}
              props={this.props}
              notePropsToApp={this.handleCardStyle}
              handleNavigation={this.handleNavigation}
            />
          </div>
          </div>
         <div class="editpage">
          <div className="setMargin" >
             <a className="navigation-link"
                href="/AddAccount">
                    <Button style={{ fontSize: '18px' , backgroundColor: '#422963', left: '0', border:'1px solid #422963'}}
                        color="white"
                        id="LinkButton"
                        title="Click to Create Event"  
                        >Add Admin </Button>
                </a>
                <div style={{flexDirection: 'row', display: 'flexWrap', marginTop: '2%'}}>
                  <table className="navigation-link">
                  <thead>
                    <tr>
                      <th className="MyAdminTable stylingheader">No.</th>
                      <th className="MyAdminTable stylingheader CellWidth">NAME</th>
                      <th className="MyAdminTable stylingheader CellWidth">EMAIL</th>
                    </tr>
                  </thead>
                  <tbody>
                   {this.createTable()}
                  </tbody>
                  </table>
                 </div>
              </div>
           </div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Delete Admin</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {localStorage.getItem('uid') == this.state.toBeDeleted.UID ? <div>
                Cannot delete logged in user.
               </div> : <div>
                  Are you sure you want to delete admin {this.state.toBeDeleted.firstName}?
              </div>}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
          </Button>
            {localStorage.getItem('uid') == this.state.toBeDeleted.UID ? null : <Button onClick={this.deleteAdmin} color="secondary" autoFocus>
              Delete
          </Button>}

          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
ManageAdmin.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(ManageAdmin);
